export enum CreatePetStepsEnum {
  preStepPetType = 'pre_step_pet_type',
  preStepSelectMethod = 'pre_step_select_method',
  preStepAI = 'pre_step_ai',
  generalBase = 'general_base',
  generalSecond = 'general_second',
  coverPhoto = 'cover_photo',
  insuranceBase = 'insurance_base',
  share = 'share',
  congratulations = 'congratulations',
}
